module.exports = __webpack_public_path__ + "img/032.17d381f8.png";